import { Preferences } from '@capacitor/preferences';

export const setCapacitorPreference = async (name, value) => {
  await Preferences.set({
    key: name,
    value: value,
  });
};

export const getCapacitorPreference = async (name) => {
  const { value } = await Preferences.get({ key: name });

  return value
};

export const removeCapacitorPreference = async (name) => {
  await Preferences.remove({ key: name });
};